import { render, staticRenderFns } from "./View6.vue?vue&type=template&id=8168588e&scoped=true&"
import script from "./View6.vue?vue&type=script&lang=js&"
export * from "./View6.vue?vue&type=script&lang=js&"
import style0 from "./View6.vue?vue&type=style&index=0&id=8168588e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8168588e",
  null
  
)

export default component.exports